import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=26c97300&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c97300')) {
      api.createRecord('26c97300', component.options)
    } else {
      api.reload('26c97300', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=26c97300&", function () {
      api.rerender('26c97300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pk6z5v8ENg7O/JS/comp/ImgFallback.vue"
export default component.exports